import { graphqlShopifyStorefront } from "@repo/graphql-shopify-storefront";

export const MailingAddress_Fragment = graphqlShopifyStorefront(`
  fragment MailingAddress on MailingAddress {
    address1
    address2
    city
    company
    country
    countryCodeV2
    firstName
    formatted
    formattedArea
    id
    lastName
    name
    phone
    province
    provinceCode
    zip
  }
`);
